<template>
  <div :class="getResponsiveClass">
    <a :href="getAppLinkByIDAndType(linkID, linkType)" class="router-link" @click="trackClickEvent(linkID, linkType)">
      <div class="villa-card" :style="setCardStyles">
        <div v-if="!!imgURL" class="villa-image-holder" :style="setImageWidth">
          <img ref="villaimg" :data-src="imgURL" :alt="title" class="villa-card-image lazyload" :title="title">
        </div>
        <span class="long-arrow" />
        <div ref="details" class="villa-card-details">
          <!--only display 'Villas' label if type is 'collection', because then the description is always the count of villas in the collection-->
          <p v-if="!!description && linkType === 'collection'" class="villa-card-count"><span class="bold">{{ description }}</span> Villas</p>
          <p v-else class="villa-card-count"><span class="semi-bold">{{ description }}</span></p>
          <p class="villa-card-title" :style="titleStyle">{{ title }}</p>
        </div>
      </div>
    </a>
    <div v-if="showCloseButton" class="close-btn" @click="close">
      <font-awesome-icon icon="times" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VillaCard',
  props: {
    title: { type: String, required: true },
    imgURL: { type: String, required: false },
    linkID: { type: String, required: false },
    linkType: { type: String, required: false, default: 'collection' },
    description: { type: String, required: false },
    cardWidth: { type: String, default: '300px' },
    cardHeight: { type: String, default: '350px' },
    responsive: { type: Boolean, default: true },
    showCloseButton: { type: Boolean, default: false },
    aspectRatio: { type: Number, default: 0.66 },
  },
  data() {
    return {
      windowWidth: null,
      maxWidth: '420px',
    };
  },
  computed: {
    getResponsiveClass() {
      return {
        responsive: this.responsive,
      };
    },
    componentWidth() {
      return parseInt(this.cardWidth) > parseInt(this.maxWidth) ? this.maxWidth : this.cardWidth;
    },
    setCardStyles() {
      return {
        width: this.screenWidth < 970 && this.responsive ? '100%' : this.componentWidth,
        maxWidth: this.screenWidth < 970 && this.responsive ? this.maxWidth : this.componentWidth,
        height: this.cardHeight,
      };
    },
    setImageWidth() {
      const imageWidth = parseInt(this.componentWidth) - 20;
      this.calculateImageHeight;
      return {
        width: this.screenWidth < 970 && this.responsive ? '100%' : `${imageWidth}px`,
        maxWidth: this.maxWidth,
        height: this.screenWidth < 970 && this.responsive ? 'auto' : `${this.calculateImageHeight}px`,
      };
    },
    calculateImageHeight() {
      const imgWidth = this.$refs.villaimg ? this.$refs.villaimg.getBoundingClientRect().width : parseInt(this.componentWidth) - 20;
      return this.aspectRatio * imgWidth;
    },
    screenWidth() {
      return this.windowWidth;
    },
    titleStyle() {
      return {
        marginTop: this.description ? '0px' : '10px',
      };
    },

  },
  mounted() {
    window.addEventListener('resize', this.onScreenResize);
    this.onScreenResize();
  },
  methods: {
    getAppLinkByID(pageID) {
      return this.$store.getters['applinks/getLink']('page', pageID).url;
    },
    trackClickEvent(pageID, pageType) {
      if (pageType === 'collection') {
        try {
          // get collection url
          const url = this.$store.getters['applinks/getLink'](pageType, pageID) ? this.$store.getters['applinks/getLink'](pageType, pageID).url : '';
          // track collection click (for exponea)
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'click', click_name: 'collection', collectionId: `${pageID}`, collectionUrl: `${url}`,
          });
        } catch (error) { console.error(error); }
      }
    },
    getAppLinkByIDAndType(pageID, pageType) {
      // if the pageID is a URL then no need to get it from applinks
      if (isNaN(pageID)) return pageID;
      return this.$store.getters['applinks/getLink'](pageType, pageID) ? this.$store.getters['applinks/getLink'](pageType, pageID).url : '';
    },

    gotoPage(pageID, type) {
      if (pageID) {
        parseInt(pageID) > 0 ? window.location = this.getAppLinkByIDAndType(pageID, type) : window.location = pageID;
      }
    },
    onScreenResize() {
      this.windowWidth = document.documentElement.clientWidth;
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings/config.scss";
$card-width: 300px;
$card-height: 350px;
$max-width: 420px;

.villa-card {
    background-color: $stoneLight;
    height: $card-height;
    width: $card-width;
    max-width: $card-width;
    margin-bottom: 20px;
    padding: 10px;
    position: relative;
    cursor: pointer;
    overflow: hidden;

    .long-arrow {
        position: absolute;
        right: 20px;
        bottom: 20px;
        color: $ochre;
    }
}

.villa-image-holder{
    width: calc(#{$card-width - 20px});
    height: 190px;
    overflow: hidden;
    max-width: $max-width;
    background-color: transparent;
}

.villa-card-image{
    width: 100%;
    height: auto;
}

.villa-card-details{
    padding: 0 20px;
}

.villa-card-count{
     @include body-text;
     font-size: 14px;
     color: $grey;
     font-weight: 400;
     margin-top: 10px;
}

.villa-card-title{
    font-size: 21px;
    font-weight: 400;
    color: $darkBlack;
}

.close-btn{
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: $stoneWhite;
    border: 1px solid $silver;
    width:30px;
    height: 30px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
}

.responsive{
    @media (max-width: 970px)  {
        .villa-card {
            width: 100%;
            max-width: $max-width;
            height:auto;
            min-height: 430px;
            max-height: 430px;
        }
        .villa-image-holder{
            width: 100%;
            height: auto;
        }
        .villa-card-image{
            width: 100%;
            height: auto;
        }
    }
}

</style>
